<!-- eslint-disable no-unused-vars -->
<!--
<template>
  <v-card class="boxItem">
    
    <v-card-title>{{ job.task_name }}</v-card-title>
    <v-card-subtitle>
      {{ job.task_id }} 
    </v-card-subtitle>
    <v-card-text>
      
      {{ this.job.status }} 
      <br><br>
      <v-chip text-color="black" prepend-icon="mdi-calendar-start">
        {{ this.job.execute_time }}
      </v-chip>

      </v-card-text>
  </v-card>
</template>
-->

<template>
  <v-card class="w-full max-w-2xl shadow-lg p-4 bg-gray-900 rounded-2xl border border-gray-700">
    <!-- Título y Estado -->
    <div class="w-full flex ">
      <h2 class="flex text-xl font-bold  text-gray-100"> <v-icon color="blue-lighten-3" class="mr-2">mdi-airplane</v-icon>{{ task.task_name }} </h2>
      <h2 class="flex ml-auto text-xl font-bold  text-gray-100">
        
        <v-chip v-if="specialCase" color="yellow"
              class="text-white mx-2" label>
              <v-icon start small>mdi-check-circle</v-icon>
              Batería insuficiente
        </v-chip> 
          <v-chip v-else :color="statusColor(task.status)"
              class="text-white mx-2" label>
              <v-icon start small>mdi-check-circle</v-icon>
              {{ getStatusLabel(task.status) }}
        </v-chip> 
      </h2>
      
    </div>
    <div class="flex justify-between items-center mb-2">

      <div class="flex items-center gap-2 my-2">
        <div>
          
          <p v-if="manualFlight == false" class="text-sm text-gray-400 truncate">{{ task.file_name }}</p>
          <p v-if="manualFlight == false && task.error_code != 0" class="text-xs pt-2 text-gray-500 ">{{ task.error_code
            + " - " + this.getCodeError(task.error_code) + ""}}</p>
          <p v-if="manualFlight == true && task.return_reason != 0" class="text-xs pt-2 text-gray-500 ">{{ "Codigo " + task.return_reason
            + " - " + this.getReturnReasonLabel(task.return_reason) + ""}}</p>
            
        </div>
      </div>

    </div>

    <!-- Información base -->
    <div class="grid grid-cols-2 gap-3 text-sm text-gray-300 mb-3">
      <div class="flex items-center gap-2">
        <v-icon color="gray-lighten-2">mdi-drone</v-icon>
        {{ task.drone_sn }}
      </div>
      <div class="flex items-center gap-2">
        <v-icon color="gray-lighten-2">mdi-dock-top</v-icon>
        {{ task.dock_name }} ({{ task.dock_sn }})
      </div>
      <div v-if="manualFlight == false" class="flex items-center gap-2">
        <v-icon color="gray-lighten-2">mdi-account</v-icon>
        {{ task.username }}
      </div>
      <div class="flex items-center gap-2">
        <!--
        <v-icon color="gray-lighten-2">mdi-calendar-clock</v-icon>
        {{ formatDate(task.execute_time) }}
         -->
      </div>
    </div>

    <!-- Progreso 
    <v-progress-linear
      :model-value="task.progress"
      color="blue-lighten-1"
      height="8"
      rounded
      class="mb-4"
    />
    -->

    <!-- Tiempos -->
    <div class="grid grid-cols-2 gap-2 text-xs text-gray-400 mb-4">
      <!--
      <p v-if="manualFlight == false"><v-icon small class="mr-1">mdi-clock-start</v-icon><strong>Inicio:</strong> {{
        formatDate(task.begin_time) }}</p>
      <p v-if="manualFlight == false"><v-icon small class="mr-1">mdi-clock-end</v-icon><strong>Fin:</strong> {{
        formatDate(task.end_time) }}</p>
      
      <p><v-icon small class="mr-1">mdi-airplane-takeoff</v-icon><strong>Despegue:</strong> {{
        formatDate(task.takeoff_time) }}</p>
      -->
      <p ><v-icon small class="mr-1">mdi-airplane-takeoff</v-icon><strong>Despegue:</strong> {{
        formatDate(task.execute_time) }}</p>

      <p v-if="isNotExecuting"><v-icon small class="mr-1">mdi-airplane-landing</v-icon><strong>Aterrizaje:</strong> {{
        formatDate(task.landing_time) }}</p>
      <!--
      <p><v-icon small class="mr-1">mdi-check</v-icon><strong>Completado:</strong> {{ formatDate(task.completed_time) }}
      </p>
      -->
      <!--<p><v-icon small class="mr-1">mdi-timer</v-icon><strong>Duración:</strong> {{ formatRuntime(task.run_time) }}</p>-->
      <p v-if="isNotExecuting"><v-icon small class="mr-1">mdi-timer</v-icon><strong>Duración:</strong> {{ this.duration }}</p>
    </div>

    <!-- Panel de errores -->

    <v-expansion-panels v-if="task.drone_hms.length" class="bg-gray-800 rounded-lg">
      <v-expansion-panel>
        <v-expansion-panel-title class="text-sm font-semibold text-red-400">
          <v-icon small class="mr-1 text-red-400">mdi-alert</v-icon>
          Eventos del dron ({{ task.drone_hms.length }})
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <ul class="list-disc list-inside text-xs text-gray-300">
            <li v-for="(hms, index) in task.drone_hms" :key="index">
              <strong>Código </strong> {{ hms.code }} |
              {{ getHmsDrone(hms.code) }} 
              <!--<strong>Nivel:</strong> {{ hms.level }} |
              <strong>Módulo:</strong> {{ hms.module }} |
              <strong>En vuelo:</strong> {{ hms.in_the_sky ? 'Sí' : 'No' }}
              -->

            </li>
          </ul>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>



<script>
/* eslint-disable */

import { format } from 'date-fns'
import { taskDeleteService } from "@/services/taskService";
import errorCodes from './taskError';
import router from "@/router";
import { hmsDrone } from "./hmsDrone"



function formatDate(dateStr) {
  try {
    const date = new Date(dateStr)
    const timezoneOffset = date.getTimezoneOffset()
    const utcDate = new Date(date.getTime() - (timezoneOffset * 60 * 1000))
    return format(utcDate, 'PPpp')
  } catch {
    return dateStr
  }
}

function formatRuntime(duration) {
  if (!duration) return '-'
  const match = duration.match(/PT(\d+)S/)
  if (match) {
    const seconds = parseInt(match[1])
    const minutes = Math.floor(seconds / 60)
    const sec = seconds % 60
    return `${minutes}m ${sec}s`
  }
  return duration
}

function getStatusLabel(status) {
  const map = {
    1: 'Planificada',
    2: 'Ejecutando',
    3: 'Completada',
    4: 'Cancelada',
    5: 'Fallida',
    6: 'Pausada',
    7: 'Completada Parcialmente',
    8: 'Rechazada',
    9: 'Timeout',
  }
  if (status == -1) {
    return 'Desconocido'
  }

  return map[status] || 'Desconocido'
}

function getReturnReasonLabel(errorCode) {
  const map = {
    0: 'Sin significado',
    1: 'Energía de batería insuficiente (retorno, aterrizaje)',
    2: 'Voltaje de batería insuficiente (retorno, aterrizaje)',
    3: 'Voltaje severamente bajo (retorno, aterrizaje)',
    4: 'Solicitado por botones del control remoto (despegue, retorno, aterrizaje)',
    5: 'Solicitado por la App (despegue, retorno, aterrizaje)',
    6: 'Pérdida de señal del control remoto (retorno, aterrizaje, hover)',
    7: 'Activado por dispositivos externos como navegación, SDK, etc. (despegue, retorno, aterrizaje)',
    8: 'Ingresó a la zona GEO del dock (aterrizaje)',
    9: 'Aunque se activó un retorno, estaba demasiado cerca del punto de origen (aterrizaje)',
    10: 'Aunque se activó un retorno, estaba demasiado lejos del punto de origen (aterrizaje)',
    11: 'Solicitado al ejecutar misiones de puntos de ruta (despegue)',
    12: 'Solicitado después de alcanzar por encima del punto de origen en la fase de retorno (aterrizaje)',
    13: 'Descenso continuo a pesar de que la altura de la aeronave bajó a 0.7m del suelo (límite de descenso de segunda etapa) llevando a (aterrizaje)',
    14: 'Ruptura forzada de la protección de baja altitud por dispositivos como App, SDK (aterrizaje)',
    15: 'Solicitado debido a vuelos que pasan en las cercanías (retornando, aterrizaje)',
    16: 'Solicitado debido a falla en el control de altura (retorno, aterrizaje)',
    17: 'Ingresado después del retorno inteligente por batería baja (aterrizaje)',
    18: 'AP controla el modo de vuelo (vuelo manual)',
    19: 'Hardware anormalmente (retorno, aterrizaje)',
    20: 'Fin de la protección anticolisión (aterrizaje)',
    21: 'Retorno cancelado (hover)',
    22: 'Obstáculos encontrados durante el retorno (aterrizaje)',
    23: 'Activado por vientos fuertes en la escena del dock (retorno)'
  }
  
  if (errorCode == -1) {
    return 'Desconocido'
  }

  return map[errorCode] || 'Código de error no definido'
}

function statusColor(status) {
  switch (status) {
    case 3: return 'green'
    case 7: return 'yellow'
    case 5: return 'red'
    case 2: return 'blue'
    default: return 'grey'
  }
}

export default {
  name: "TaskBox",
  props: {
    task: Object,
  },
  components: {},
  setup() { },
  mounted() {
    //this.status = this.getStatusString(this.job.status);
    //this.color = this.getColor(this.job.status);
    this.duration = this.getDuration();
    //this.code = this.job.code;
    //console.log(this.job)
  },
  data: () => ({
    status: "",
    color: "",
    duration: 0,
  }),
  methods: {
    formatDate,
    formatRuntime,
    getStatusLabel,
    statusColor,
    getReturnReasonLabel,
    getStatusString(status) {
      if (status == 2) {
        if (this.closedByRTH) {
          return "Cerrado por RTH";
        }
      }
      const s = [
        "Pendiente de ejecución",
        "En ejecución",
        "Completado",
        "Cancelado",
        "Error",
        "Pausada",
      ];
      return s[status - 1];
    },
    getColor(status) {
      const s = ["blue", "yellow", "green", "gray", "red", "yellow"];
      return s[status - 1];
    },
    getCodeError(code) {
      return errorCodes[code];
    },
 
    getHmsDrone(hms) {
      return hmsDrone[hms]
    },
    getDuration() {
      let r = new Date(this.task.landing_time) - new Date(this.task.execute_time);
      r = r / 1000;
      let minutes = Math.floor(r / 60);
      let seconds = r - minutes * 60;
      if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
      } else {
        return `${seconds}s`;
      }
    },
    async deleteTask() {
      await taskDeleteService(this.job.job_id);
      router.go();
    },
  },
  computed: {
    rreason () {
      const code = this.task.return_reason;


    }, 
    isNotExecuting() {
      return this.task.status != 2
    },
    specialCase() {
      const t = this.task;
      if (t.error_code == "322281" || t.error_code == "321773") {
        return true;
      } else {
        return false;
      }
    },
    manualFlight() {
      return this.task.file_name == 0;
    },
    beginDate() {
      try {
        const ds = this.job.begin_time.split(" ");
        const ds1 = ds[0].split("-");
        const ds2 = ds[1].split(":");
        //const d = Date(Date.UTC(ds1[0], ds1[1], ds1[2], ds2[3], ds2[4], ds2[5]));
        //console.log(d)
        const d = Date.parse(ds[0] + "T" + ds[1] + ".000Z");
        return new Date(d).toLocaleString();
        //return new Date(d).toLocaleString();

      }
      catch (error) {
        return null;
      }
    },
    completedDate() {
      try {
        const ds = this.job.completed_time.split(" ");
        console.log(ds)
        const ds1 = ds[0].split("-");
        const ds2 = ds[1].split(":");
        //console.log(ds1, ds2)
        //const d = Date(Date.UTC(ds1[0], ds1[1]-1, ds1[2], ds2[3], ds2[4], ds2[5]));
        //console.log(ds)
        //console.log(d)
        const d = Date.parse(ds[0] + "T" + ds[1] + ".000Z");
        return new Date(d).toLocaleString();
      } catch (error) {
        return null;
      }
    },
    closedByRTH() {
      try {
        const ds = this.job.begin_time.split(" ");
        const d = Date.parse(ds[0] + "T" + ds[1] + ".000Z");
        const now = new Date()
        let r = now - d;
        r = r / 1000;
        let minutes = Math.floor(r / 60);
        if (minutes > 40) {
          return true
        } else {
          return false
        }

      } catch (e) {
        console.log(e)
        return true
      }
    }
  },

};
</script>

<style scoped>
.container {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.boxItem {
  margin: 0px;
  padding: 10px;
}
</style>
